import { createContext } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { default as Routes } from './routes/Routes';
import { default as Header } from 'components/layout/header/Header';
import { Layout } from 'antd';
import './app.scss';

const { Content } = Layout;

export const Context = createContext<any>({ config: {}, installType: "" });

function App() {
  return (
    <>
      <Header />
      <Content className="content-layout">
        <Context.Provider value={{ config: {} }}>
          <Router>
            <Routes />
          </Router>
        </Context.Provider>
      </Content>
    </>
  );
}

export default App;
